import { useState, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

// Code-Splitting: Wizard zuerst (Hauptseite), Admin-Pages danach lazy.
// Reduziert das initial Bundle für /wizard von ~275KB auf nur den Wizard-Code,
// alle Admin-Pages werden erst beim Besuch der Admin-Seiten geladen.
const WizardPage = lazy(() => import("./pages/WizardPage"));
const Layout = lazy(() => import("./components/Layout"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const ProductsPage = lazy(() => import("./pages/ProductsPage"));
const SyncPage = lazy(() => import("./pages/SyncPage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const LogsPage = lazy(() => import("./pages/LogsPage"));
const OrdersPage = lazy(() => import("./pages/OrdersPage"));
const AccountingPage = lazy(() => import("./pages/AccountingPage"));
const DraftsPage = lazy(() => import("./pages/DraftsPage"));

const PageFallback = () => (
  <div style={{ minHeight: "60vh", background: "#fff" }} />
);

function App() {
  const [user, setUser] = useState(localStorage.getItem("vollsync_user"));

  const handleLogin = (username) => setUser(username);
  const handleLogout = () => setUser(null);

  const ProtectedRoute = ({ children }) => {
    if (!user) return <Navigate to="/login" replace />;
    return children;
  };

  return (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/wizard" element={<WizardPage />} />
          <Route path="/login" element={
            user ? <Navigate to="/" replace /> : <LoginPage onLogin={handleLogin} />
          } />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout user={user} onLogout={handleLogout} />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardPage />} />
            <Route path="produkte" element={<ProductsPage />} />
            <Route path="sync" element={<SyncPage />} />
            <Route path="einstellungen" element={<SettingsPage />} />
            <Route path="protokolle" element={<LogsPage />} />
            <Route path="bestellungen" element={<OrdersPage />} />
            <Route path="buchhaltung" element={<AccountingPage />} />
            <Route path="entwuerfe" element={<DraftsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
